// memory cache
import crypto from 'crypto';
export default class ObjectCache<T> {
    private cache: Map<Object, T>;
    constructor() {
        this.cache = new Map();
    }
    private _hex(target: string) {
        const md5 = crypto.createHash('md5');
        return md5.update(target).digest('hex');
    }
    private _sort(unordered: Object) {
        return Object.keys(unordered)
            .sort()
            .reduce((obj, key) => {
                // @ts-ignore
                obj[key] = unordered[key];
                return obj;
            }, {});
    }
    get(key: Object) {
        const keyString = JSON.stringify(this._sort(key));
        return this.cache.get(this._hex(keyString));
    }
    set(key: Object, value: T) {
        const keyString = JSON.stringify(this._sort(key));
        return this.cache.set(this._hex(keyString), value);
    }
    delete(key: Object) {
        const keyString = JSON.stringify(this._sort(key));
        return this.cache.delete(this._hex(keyString));
    }
    clear() {
        this.cache.clear();
    }
}
